/**
 * Call for Price functionality
 * Handles showing/hiding add to cart and price elements for $0 products
 * Dynamically updates when variant changes
 */

(function() {
  'use strict';

  // Listen for variant changes on product pages
  document.addEventListener('DOMContentLoaded', function() {
    // Check if we're on a product page
    const productForms = document.querySelectorAll('[data-product-form]');
    
    if (productForms.length === 0) return;

    // Listen for variant change events
    document.addEventListener('product:variant-change', function(event) {
      const variant = event.detail.variant;
      
      if (!variant) return;

      // Find all product form containers
      productForms.forEach(function(form) {
        handleVariantChange(form, variant);
      });

      // Handle sticky ATC bar
      handleStickyBarVariantChange(variant);
    });

    // Also listen for standard variant select changes
    const variantSelects = document.querySelectorAll('[data-variant-select]');
    variantSelects.forEach(function(select) {
      select.addEventListener('change', function(e) {
        const variantId = e.target.value;
        // Find variant data from the page
        const variantData = getVariantById(variantId);
        if (variantData) {
          productForms.forEach(function(form) {
            handleVariantChange(form, variantData);
          });
          handleStickyBarVariantChange(variantData);
        }
      });
    });
  });

  /**
   * Handle variant change for a product form
   */
  function handleVariantChange(form, variant) {
    const isZeroPrice = variant.price === 0 && variant.available;
    
    // Find the submit controls group
    const controlsGroup = form.querySelector('.product-form__controls-group--submit');
    if (!controlsGroup) return;

    // Find or create call for price wrapper
    let callForPriceItem = controlsGroup.querySelector('.product-form__item--call-for-price');
    const submitItem = controlsGroup.querySelector('.product-form__item--submit:not(.product-form__item--call-for-price)');
    
    if (isZeroPrice) {
      // Show call for price, hide add to cart
      if (submitItem) {
        submitItem.style.display = 'none';
      }
      
      if (callForPriceItem) {
        callForPriceItem.style.display = 'block';
      } else {
        // Create call for price button if it doesn't exist
        // This would require the button to be pre-rendered or use AJAX
        // For now, we'll just hide the submit button
        console.warn('Call for price button not found in form');
      }

      // Hide price in header
      hidePriceDisplay(true);
      
    } else {
      // Show add to cart, hide call for price
      if (callForPriceItem) {
        callForPriceItem.style.display = 'none';
      }
      
      if (submitItem) {
        submitItem.style.display = 'block';
      }

      // Show price in header
      hidePriceDisplay(false);
    }
  }

  /**
   * Handle sticky bar visibility for variant changes
   */
  function handleStickyBarVariantChange(variant) {
    const stickyBar = document.querySelector('.sticky-atc-bar');
    if (!stickyBar) return;

    const isZeroPrice = variant.price === 0 && variant.available;
    
    if (isZeroPrice) {
      stickyBar.style.display = 'none';
      stickyBar.setAttribute('data-hide-for-zero', 'true');
    } else {
      stickyBar.removeAttribute('style');
      stickyBar.setAttribute('data-hide-for-zero', 'false');
    }
  }

  /**
   * Hide/show price display in product header
   */
  function hidePriceDisplay(hide) {
    const priceWrapper = document.querySelector('.product__price');
    if (!priceWrapper) return;

    if (hide) {
      priceWrapper.style.display = 'none';
    } else {
      priceWrapper.style.display = '';
    }
  }

  /**
   * Get variant data by ID from page
   */
  function getVariantById(variantId) {
    // Try to get variant data from window.theme or data attributes
    if (window.theme && window.theme.productVariants) {
      return window.theme.productVariants.find(function(v) {
        return v.id === parseInt(variantId);
      });
    }
    return null;
  }

})();

